import React from 'react';

export default function TokenomicsSection() {
  return (
    <section className="tokenomics-section" id="tokenomics">
      <div className="tokenomics-container">
        <h2 className="section-title">Tokenomics</h2>

        <div className="feature-card feature-1">
          <div className="feature-content">
            <span className="feature-tag">TOKEN UTILITY</span>
            <h3>Multiple Use Cases<br/>For <span className="highlight-red">BGG</span> <span className="highlight-purple">Token</span></h3>
            <p>Access AI-powered analytics, participate in staking for rewards, enable trustless transactions on DEX, and provision liquidity within the ecosystem.</p>
            <button className="feature-btn">Learn More <span>→</span></button>
          </div>
          <div className="feature-image">
            <img src="assets/1.png" alt="Token Utility" className="feature-img" />
          </div>
        </div>

        <div className="feature-card feature-2">
          <div className="feature-image">
            <img src="assets/2.png" alt="Fixed Supply" className="feature-img" />
          </div>
          <div className="feature-content">
            <span className="feature-tag">TOKENOMICS</span>
            <h3>Fixed Supply Model<br/>For <span className="highlight-red">Value</span> <span className="highlight-purple">Protection</span></h3>
            <p>With only 10,000,000 BGG tokens in circulation, scarcity is guaranteed. Strategic token distribution supports liquidity, ecosystem development, AI infrastructure, community rewards, and growth partnerships.</p>
            <div className="feature-items">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <div>
                  <strong>Liquidity Provisioning</strong>
                  <p>for market stability</p>
                </div>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <div>
                  <strong>AI Infrastructure</strong>
                  <p>for ecosystem optimization</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="feature-card feature-3">
          <div className="feature-content">
            <span className="feature-tag">SECURITY & TRUST</span>
            <h3>Blockchain Security<br/>With <span className="highlight-red">AI</span> <span className="highlight-purple">Protection</span></h3>
            <p>Smart contracts combined with AI-driven risk assessment ensure the highest protection for user assets and transactions. Built with transparency, decentralization, and intelligent automation.</p>
            <button className="feature-btn">Explore <span>→</span></button>
          </div>
          <div className="feature-image">
            <img src="assets/3.png" alt="AI Protection" className="feature-img" />
          </div>
        </div>
      </div>
    </section>
  );
}
